import { useQuery } from '@tanstack/react-query'
import { useUserId } from '~/components/user/SessionProvider'
import { trpc } from '~/lib/trpc'

export const getContactInterestQueryKey = (contactId: string): readonly unknown[] =>
  trpc.feedback.contactInterestStatus.queryOptions({ contactId }).queryKey

export function useContactInterest(contactId: string | undefined) {
  const userId = useUserId()
  const queryOptions = trpc.feedback.contactInterestStatus.queryOptions({
    contactId: contactId ?? '',
  })

  return useQuery({
    ...queryOptions,
    enabled: !!userId && !!contactId,
    staleTime: 0,
  })
}
